"use strict";
var $ = require("../internals/export");
var uncurryThis = require("../internals/function-uncurry-this");
var requireObjectCoercible = require("../internals/require-object-coercible");
var toIntegerOrInfinity = require("../internals/to-integer-or-infinity");
var toString = require("../internals/to-string");
var stringSlice = uncurryThis("".slice);
var max = Math.max;
var min = Math.min;
var FORCED = !"".substr || "ab".substr(-1) !== "b";
$({ target: "String", proto: true, forced: FORCED }, {
  substr: function substr(start, length) {
    var that = toString(requireObjectCoercible(this));
    var size = that.length;
    var intStart = toIntegerOrInfinity(start);
    var intLength, intEnd;
    if (intStart === Infinity) intStart = 0;
    if (intStart < 0) intStart = max(size + intStart, 0);
    intLength = length === void 0 ? size : toIntegerOrInfinity(length);
    if (intLength <= 0 || intLength === Infinity) return "";
    intEnd = min(intStart + intLength, size);
    return intStart >= intEnd ? "" : stringSlice(that, intStart, intEnd);
  }
});
